<template>
  <div class="bmi-container">
    <h2>BMI计算器</h2>
    <div class="input-group">
      <input type="number" v-model.number="height" placeholder="身高（厘米）" />
      <input type="number" v-model.number="weight" placeholder="体重（公斤）" />
    </div>
    <button @click="calculateBMI">计算BMI</button>
    <p v-if="bmi">您的BMI值是: {{ bmi.value }} ({{ bmi.category }})</p>
    <div class="bmi-table-container">
      <table class="bmi-table">
        <thead>
          <tr>
            <th>BMI范围</th>
            <th>状态</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="range in bmiRanges" :key="range.text">
            <td>{{ range.low }} - {{ range.high }}</td>
            <td :class="getStatusClass(range.status)">{{ range.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "BMIIndex",
  data() {
    return {
      height: null,
      weight: null,
      bmi: null,
      bmiRanges: [
        { low: 0, high: 18.4, status: "过轻" },
        { low: 18.5, high: 23.9, status: "正常范围" },
        { low: 24, high: 27.9, status: "过重" },
        { low: 28, high: 31.9, status: "肥胖" },
        { low: 32, high: 39.9, status: "严重肥胖" },
        { low: 40, high: 59.9, status: "极重肥胖" },
      ],
    };
  },
  methods: {
    calculateBMI() {
      if (this.height > 0 && this.weight > 0) {
        const heightInMeters = this.height / 100;
        const weightInKilograms = this.weight;
        const bmiValue = weightInKilograms / (heightInMeters * heightInMeters);

        this.bmi = {
          value: bmiValue.toFixed(1),
          category: this.getBMICategory(bmiValue),
        };
      } else {
        alert("请输入有效的身高和体重值。");
      }
    },

    getBMICategory(bmiValue) {
      for (const range of this.bmiRanges) {
        if (bmiValue >= range.low && bmiValue <= range.high) {
          return range.status;
        }
      }
      return "未知";
    },

    getStatusClass(status) {
      const classes = {
        过轻: "status-light",
        正常范围: "status-normal",
        过重: "status-overweight",
        肥胖: "status-obese",
        严重肥胖: "status-severely-obese",
        极重肥胖: "status-very-severely-obese",
      };
      return classes[status] || "status-unknown";
    },
  },
};
</script>

<style lang="less" scoped>
.bmi-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  text-align: center;
}

h2 {
  margin-bottom: 16px;
  font-size: 24px;
  color: #333;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

input {
  height: 40px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
}

input:focus {
  border-color: #4caf50;
  box-shadow: 0 0 6px rgba(76, 175, 80, 0.3);
}

button {
  width: 100%;
  height: 40px;
  margin: 16px 0;
  background-color: #4caf50;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #45a049;
}

p {
  margin: 16px 0;
  font-size: 18px;
  color: #666;
}

.bmi-table-container {
  margin: 20px auto;
  overflow-x: auto;
}

.bmi-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
}

.bmi-table th,
.bmi-table td {
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 14px;
  white-space: nowrap;
}

.bmi-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.status-light {
  background-color: #ffcccc;
}

.status-normal {
  background-color: #ccffcc;
}

.status-overweight {
  background-color: #ffffcc;
}

.status-obese {
  background-color: #ffcc00;
}

.status-severely-obese {
  background-color: #cc6600;
}

.status-very-severely-obese {
  background-color: #993300;
}

.status-unknown {
  background-color: #eee;
}

/* 响应式设计 */
@media (max-width: 600px) {
  .bmi-container {
    max-width: 100%;
    padding: 16px;
  }

  h2 {
    font-size: 20px;
  }

  input {
    font-size: 14px;
  }

  button {
    font-size: 14px;
  }

  p {
    font-size: 16px;
  }

  .bmi-table th,
  .bmi-table td {
    font-size: 12px;
    padding: 8px;
  }
}
</style>
